import CheckCircleIcon from "assets/icon/CheckCircleIcon"

export default function CompleteButton(props){
    return(
        <button className={`button flex gap-2 ${ props?.visible ? 'block' : 'hidden' }`} onClick={props?.onClick}>
            <CheckCircleIcon className="fill-white w-6" />
            <span>Complete</span>
        </button>
    )
}